export default "__VITE_ASSET__DigvTEq1__"